import { render, staticRenderFns } from "./multiTenantForm.vue?vue&type=template&id=15526a55&scoped=true&"
import script from "./multiTenantForm.vue?vue&type=script&lang=js&"
export * from "./multiTenantForm.vue?vue&type=script&lang=js&"
import style0 from "./multiTenantForm.vue?vue&type=style&index=0&id=15526a55&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15526a55",
  null
  
)

export default component.exports